// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2057":"23399b5ec0f34fb4","4865":"1cc382f491387f73","6058":"b9105371c60072ad","9256":"00d79f28bcfa56fb"}[chunkId] + ".css";
};